<template>
  <div class="users">
    <div class="users__score-distribution">
      <h2>User Score Distribution</h2>
      <div class="score-distribution__controls">
        <base-form-input label="Bucket Size">
          <input v-model.number="bucketSize" type="number" min="10" step="10" @change="onBucketSizeChange" />
        </base-form-input>
        <base-button @click="loadScoreDistribution" :disabled="loadingDistribution">Refresh</base-button>
      </div>
      <app-score-histogram
        v-if="scoreDistribution.length > 0 && !loadingDistribution"
        :distribution="scoreDistribution"
        :bucket-size="bucketSize"
      />
      <p v-else-if="loadingDistribution">Loading score distribution...</p>
      <p v-else>No score distribution data available</p>
    </div>
  </div>
</template>

<script lang="ts">
import AppScoreHistogram from '@/components/ScoreHistogram.vue';
import gql from 'graphql-tag';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: { AppScoreHistogram },
})
export default class SearchStatisticsView extends Vue {
  bucketSize = 100;
  scoreDistribution: number[] = [];
  loadingDistribution = false;

  public created() {
    this.loadScoreDistribution();
  }

  public onBucketSizeChange() {
    // Clear the current distribution data to prevent showing old data with new bucket size
    this.scoreDistribution = [];
    this.loadScoreDistribution();
  }

  public async loadScoreDistribution() {
    if (this.loadingDistribution) return; // Prevent multiple simultaneous requests

    try {
      this.loadingDistribution = true;
      const { data } = await this.$apollo.query({
        query: gql`
          query ScoreDistribution($bucketSize: Int) {
            scoreDistribution(bucketSize: $bucketSize)
          }
        `,
        variables: { bucketSize: this.bucketSize },
        fetchPolicy: 'network-only',
      });
      this.scoreDistribution = data.scoreDistribution;
    } catch (error) {
      console.error('Failed to load score distribution:', error);
    } finally {
      this.loadingDistribution = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.users {
}

.users__form {
  margin-bottom: 8px;
  display: flex;
  align-items: flex-end;

  .form__input {
    flex-grow: 1;
    max-width: 400px;
    margin-right: 8px;
  }
}

.users__list {
}

.list__user {
  &:not(:last-child) {
    margin-bottom: 8px;
  }
}

.users__score-distribution {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #eaeaea;

  h2 {
    margin-bottom: 16px;
  }
}

.score-distribution__controls {
  display: flex;
  align-items: flex-end;
  margin-bottom: 16px;

  input {
    width: 100px;
  }

  button {
    margin-left: 16px;
  }
}
</style>
